export const MINTOLOGY_API_ENDPOINT = {
  DEV: "https://api.mintology.dev",
  PROD: "https://api.mintology.app",
};
